
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import CommissionService from "@/services/auth/CommissionService";
import DateRangePicker from "vue2-daterange-picker";
import SquadService from "@/services/auth/SquadService";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Money } from 'v-money';
import { Component, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import { mapGetters } from 'vuex'

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    Money,
    vSelect
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class ManagementCommission extends Vue {

  private commissionService = new CommissionService();
  private squadService = new SquadService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private commissionList: any;

  /**
   * @type Object
   * Actions list returned from backend
   */
  private squadList: any = [];

  /**
   * @type Object
   * insert commission
   */
  private commission: any = {
    platformId: this.$auth.user().id_platform,
    trigger_type: null,
    squad: null,
    date: null,
    itemsTriggers: [] || null
  };

   private itemsTriggers: {
          trigger: string,
          trigger_key: string,
          trigger_value: string,
          commission_value: string,
          per_attendance_value: string,
          daily_minimum_value: string,
    }[] = [];

  private fieldsTriggers = [
    { key: 'trigger', label: 'Nível' },
    { key: 'commission_value', label: 'Valor da Comissão' },
    { key: 'trigger_value', label: 'Valor Gatilho' },
    { key: 'per_attendance_value', label: 'Valor por atendimento' },
    { key: 'daily_minimum_value', label: 'Valor Fixo' },
    { key: 'actions', label: '' }
  ];

  private triggerList = [
      { key: 'bronze', label: 'Bronze' },
      { key: 'silver', label: 'Prata' },
      { key: 'gold', label: 'Ouro' },
  ];

  private triggerTypeList = [
    { key: 'VALUE', label: 'Valor' },
    { key: 'AMOUNT', label: 'Quantidade' },
    // { key: 'CONVERSION_RATE', label: 'Taxa de conversão' },
  ];


  private selectedTrigger: {
    label: string;
    key: string;
  } | null = null;

  private triggerType: string = '';
  private selectedValueTrigger: string = '';
  private selectedValueCommission: string = '';
  private selectedPerAttendanceValue: string = '';
  private selectedDailyMinimumValue: string = '';

  private commissionAttributes: [any?] = [];

  private moneyMask: any = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: true /* doesn't work with directive */
  }

  private limitDateSale  = this.$moment().add(-1, "day").format('YYYY-MM-DD HH:mm:ss');

  private dateComission = {
    startDate: "",
    endDate: ""
  }

  @Watch("dateComission.startDate")
  onChangeSaleDate(value: any, _oldValue: any) {
    this.commission.date = value;
  }

  private percentMask: any = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '%',
    precision: 2,
    masked: true /* doesn't work with directive */
  }
    private noMask: any = {
    masked: false,
    decimal: '',
    thousands: '',
    prefix: '',
    suffix: '',
    precision: 0,
  }

  /**
   * @type boolean
   */
  private validatingCommissionNull: boolean = false;
  private validatingCommissionItensNull: boolean = false;
  private isCommissionInvalid: boolean = false;
  private loading: boolean = false;

  /** Help control error form for send or not */
  private formCommissionError = {
    selectedValueCommission: { state: null as boolean | null},
    squad: { state: null as boolean | null},
    selectedValueTrigger: { state: null as boolean | null},
    selectedTrigger: { state: null as boolean | null},
    selectedDailyMinimumValue: { state: null as boolean | null},
    selectedPerAttendanceValue: { state: null as boolean | null},
    dateComission: { state: null as boolean | null},
    triggerType: { state: null as boolean | null},
  };

  /**
   * @tyoe Array
   * Define columns from datatables
   */
  private columns = [
    { data: "id_commission_rule", name: "id_commission_rule", title: "ID", orderable: true, searchable: true },
    { data: "nome_squad", name: "nome_squad", title: "Nome", orderable: true, defaultContent: "--", searchable: true },
    { data: "actions", name: "actions", title: "Ações", orderable: true, defaultContent: "--", searchable: true },
    { data: "trigger_label", name: "trigger", title: "Nível", orderable: true, searchable: true },
    { data: "trigger_type", name: "trigger_type", title: "Tipo de Gatilho", searchable: true },
    { data: "trigger_value", name: "trigger_value", title: "Valor do Gatilho", searchable: true },
    { data: "commission_value", name: "commission_value", title: "Valor", orderable: true, defaultContent: "--", searchable: true },
    { data: "daily_minimum_value", name: "daily_minimum_value", title: "Valor fixo", orderable: true, defaultContent: "--", searchable: true },
    { data: "per_attendance_value", name: "per_attendance_value", title: "Valor por atendimento", orderable: true, defaultContent: "--", searchable: true },
    { data: "is_pj", name: "contrato", title: "Contrato", searchable: true },
    { data: "status", name: "situacao", title: "Situação", orderable: true, searchable: true },
    { data: "date", name: "data", title: "Data", searchable: true },
  ];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  /**
   * Method for add new commission
   */
  private async addCommission() {
    this.validatingCommissionNull = true;
    if(this.itemsTriggers.length < 3)
        return this.isCommissionInvalid = true;

    this.loading = true;
    try {
        const result = await this.commissionService.store(this.commission);
        this.loading = false;
        this.$store.commit("navBarAlert/SUCCESS_ALERT", "Regra de Comissão registrada com sucesso");
    } catch (error) {
        console.log(error);

        this.loading = false;
        this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao registrar Regra de Comissão");
    }

    this.commissionList.ajax.reload();
    this.closecommissionModal();
  }

  private addItemCommission() {
    if(!this.commission.trigger_type)
        return this.validatingCommissionNull =  true;

    if (!this.selectedTrigger)
      return this.validatingCommissionItensNull = true

    this.validatingCommissionItensNull = false;

    const duplicateTriggerIndex = this.itemsTriggers.findIndex(e => e.trigger == this.selectedTrigger!.label);
    if (duplicateTriggerIndex >= 0)
        this.itemsTriggers.splice(duplicateTriggerIndex, 1);

    this.itemsTriggers.push(
        {
            trigger: this.selectedTrigger.label,
            trigger_key: this.selectedTrigger.key,
            commission_value: this.selectedValueCommission  || '',
            trigger_value: this.selectedValueTrigger || '',
            daily_minimum_value: this.selectedDailyMinimumValue || 'R$ 0,00',
            per_attendance_value: this.selectedPerAttendanceValue || 'R$ 0,00',
        }
    )

    if(this.commission && !this.commission.itemsTriggers)
        this.commission.itemsTriggers = [];

    this.commission.itemsTriggers.push(
        {
            trigger: this.selectedTrigger.key,
            commission_value: this.commission.trigger_type.key == 'VALUE' ?
                parseFloat(this.selectedValueCommission.replaceAll("%", '').replaceAll(".", '').replaceAll(",", '.')) * 0.01 :
                parseFloat(this.selectedValueCommission.replaceAll("R$", '').replaceAll(".", '').replaceAll(",", ".")),
            trigger_value: this.commission.trigger_type.key == 'VALUE' ?
                parseFloat(this.selectedValueTrigger.replaceAll("R$", '').replaceAll(".", '').replaceAll(",", '.')) :
                parseFloat(this.selectedValueTrigger),
            daily_minimum_value: parseFloat(this.selectedDailyMinimumValue.replaceAll("R$", '').replaceAll(".", '').replaceAll(",", '.')),
            per_attendance_value: parseFloat(this.selectedPerAttendanceValue.replaceAll("R$", '').replaceAll(".", '').replaceAll(",", '.')),
        }
    )

    this.selectedTrigger = null;
    this.selectedValueTrigger = '';
    this.triggerType = '';
    this.selectedValueCommission = '';
    this.selectedDailyMinimumValue = '';
    this.selectedPerAttendanceValue = '';
  }

  /**
   * Method close modal from add new commission and reset commission state
   */
  private closecommissionModal() {
    this.hideModal("modal-add-commission");

    this.itemsTriggers = [];
    this.commission.platformId = this.$auth.user().id_platform,
    this.selectedValueTrigger = '';
    this.selectedValueCommission = '';
    this.triggerType = '';
    this.selectedDailyMinimumValue = '';
    this.selectedPerAttendanceValue = '';
    this.validatingCommissionNull = false;
    this.validatingCommissionItensNull = false;
    this.commission.itemsTriggers = null;
    this.isCommissionInvalid = false;
    this.selectedTrigger = null;
    this.commission.trigger_type = null;
    this.commission.date = null;
    this.commission.squad = null;
    this.dateComission = {
        startDate: "",
        endDate: ""
    }
  }

  private removeItemsTrigger(item, index, element) {
    this.itemsTriggers.splice(index, 1);
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(vm) {

    if (vm.allowedFeature('management-commission'))
        this.buttons.push({ extend: "addCommission" });

    this.commissionList = this.$('#commissionList').DataTable({
       autoWidth: true,
      scrollCollapse: true,
      paging: false,
      fixedColumns: true,
      responsive: true,
      processing: true,
      order: [[0, "desc"]],
      lengthMenu: [
        [25, 50, 100],
        [25, 50, 100],
      ],
      pageLength: 25,
      scrollY: 500,
      scrollX: true,
      searching: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + "auth/commission/" + this.$auth.user().id_platform,
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },
      columnDefs: [
        {
            className: "nowrap",
            width: 200,
        }
      ],
      columns: this.columns,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.$bvModal.show("modal-add-commission");
        });
      }
    });

    this.commissionList.buttons().container().appendTo("#dt-actions");
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;
    this.loading = true;

    this.$.fn.dataTable.ext.buttons.addCommission = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar regra de comissão",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-commission");
      }
    };

    this.squadList = await this.squadService.show(this.$auth.user().id_platform);
    try {
      this.createDataTable(self);
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }

  private get selectedTriggerState() {
    return (!this.validatingCommissionItensNull && !this.selectedTrigger ) ? null :
     (this.validatingCommissionItensNull && !this.selectedTrigger) ? false : true;
  }

  private get dateComissionState() {
     return (!this.validatingCommissionNull && !this.commission.date ) ? null :
     (this.validatingCommissionNull && !this.commission.date) ? false : true;
  }

  private get triggerTypeState() {
     return (!this.validatingCommissionNull && !this.commission.trigger_type ) ? null :
     (this.validatingCommissionNull && !this.commission.trigger_type) ? false : true;
  }

   private get squadState() {
     return (!this.validatingCommissionNull && !this.commission.squad ) ? null :
     (this.validatingCommissionNull && !this.commission.squad) ? false : true;
  }
}
